import { Injectable, NgZone } from '@angular/core';
import FotosClass from '../model/api/datos/fotosClass';
import { UtilService } from './util.service';
import { Subject } from 'rxjs';
import { AlertService } from './alert.service';

declare var EXIF: any
declare var piexif: any

@Injectable({
  providedIn: 'root'
})
export class FotoService {

  public UploadFotoSubject = new Subject<FotosClass>()

  constructor(
    private util: UtilService,
    private zone: NgZone,
    private alertService: AlertService
  ) { }

  public async updateFoto(foto: FotosClass, base64: string): Promise<void> {
    let base64Data = base64.substring(base64.indexOf(",") + 1)
    foto.SHA256 = await this.util.SHA256FromBase64Data(base64Data)
    foto.FotoData = base64
  }

  public HasGPSMetadata(imageData: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      let img = document.createElement('img')
      img.src = imageData
      img.style.position = 'fixed';
      img.style.top = '10000px'
      img.style.left = '10000px'
      img.onload = async () => {
        let imageMetadata = await this.obtenerInformacionImagen(img)
        let hasGPSInfo: boolean = false
        if (
          imageMetadata != null && 
          imageMetadata["GPSLatitude"] != null && 
          imageMetadata["GPSLongitude"] != null &&
          (!isNaN(imageMetadata["GPSLatitude"][0])) &&
          (!isNaN(imageMetadata["GPSLongitude"][0])) &&
          (!isNaN(imageMetadata["GPSLatitude"][1])) &&
          (!isNaN(imageMetadata["GPSLongitude"][1])) &&
          (!isNaN(imageMetadata["GPSLatitude"][2])) &&
          (!isNaN(imageMetadata["GPSLongitude"][2]))
        ) {
          hasGPSInfo = true
        }
        img.remove()
        resolve(hasGPSInfo)
      }
      img.onerror = async (err) => {
        img.remove()
        reject(err)
      }
      document.body.appendChild(img)
    })
  }
  

  public async AdjuntarArchivo(localId: number, categoria: string, requireGPSInfo?: boolean): Promise<void> {
    if (requireGPSInfo == null) requireGPSInfo = false
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = 'image/*'
    input.style.display = 'none'
    input.multiple = true

    const _this = this
    input.onchange = async (event) => {
      const files = (event.target as HTMLInputElement).files
      let nonGPSErrors = 0
      if (files && files.length) {
        for (let i = 0; i < files.length; ++i) {
          let file = files[i]
          let base64 = await _this.SubirFichero.call(_this, file)
          if (requireGPSInfo) {
            let hasMetadata = await this.HasGPSMetadata(base64)
            if (!hasMetadata) {
              nonGPSErrors++
              continue;
            }
          }
          await _this.AddFichero.call(_this, file.name, base64, localId, categoria)
        }
      }
      if (nonGPSErrors > 0) {
        if (nonGPSErrors == 1) {
          if (files.length > 1) {
            this.alertService.showMessage(`Una de las fotos no se ha podido añadir porque no contiene información GPS.`)
          } else {
            this.alertService.showMessage(`No se ha podido añadir la foto porque no contiene información GPS.`)
          }
        } else {
          this.alertService.showMessage(`${nonGPSErrors} fotos no se han podido añadir porque no continenen información GPS.`)
        }
      }
    }

    input.click()
  }

  public SubirFichero(file: File): Promise<string> {
    return new Promise<string>((resolve) => {
      const reader = new FileReader()
      reader.onload = () => {
        const base64String = reader.result as string
        resolve(base64String)
      }
      reader.readAsDataURL(file)
    })
  }

  public async AddFichero(fileName: string, base64: string, localId: number, categoria: string): Promise<void> {

    // Añadimos la foto
    let foto = new FotosClass()
    foto.Id = 0
    foto.OrdenLocalId = localId
    foto.FileName = fileName
    foto.FotoData = base64
    foto.Categoria = categoria
    let base64Data = base64.substring(base64.indexOf(",") + 1)
    foto.SHA256 = await this.util.SHA256FromBase64Data(base64Data)

    console.log(`Fichero añadido: ${foto.FileName}`)

    this.zone.run(async () => {
      this.UploadFotoSubject.next(foto)
    })

  }

  public async AddFotoCamara(data: {data: string, hash: string}, localId: number, categoria: string): Promise<void> {
    // Añadimos la foto
    let foto = new FotosClass()
    foto.Id = 0
    foto.OrdenLocalId = localId
    foto.FileName = `Foto_${this.util.DateTimeToString(new Date()).replace(/\:/gi, '').replace(/\//gi, '')}${new Date().getMilliseconds()}.jpg`
    foto.FotoData = data.data
    foto.SHA256 = data.hash
    foto.Categoria = categoria

    console.log(`Fichero añadido: ${foto.FileName}`)

    this.zone.run(async () => {
      this.UploadFotoSubject.next(foto)
    })
  }

  public obtenerInformacionImagen(img: HTMLImageElement): Promise<any> {
    let _this = this
    return new Promise<any>(resolve => {
      EXIF.getData(<HTMLImageElement>img, () => {
        let metaData = EXIF.getAllTags(img);
        (() => {
          resolve(metaData)
        }).call(_this)
      })
    })
  }

  public async escribirMetadatosGPS(imageData: string, coordenadasGPS: GeolocationPosition): Promise<string> {
    if (window["piexif"] == null) {
      // Cargamos la librería
      await this.util.InjectScript('/assets/js/piexifjs.js');
    }
  
    try {
      let exifObj = piexif.load(imageData);
      if (exifObj["GPS"][piexif.GPSIFD.GPSLatitude] && exifObj["GPS"][piexif.GPSIFD.GPSLongitude]) {
        console.warn("La imagen ya contiene información GPS.");
        throw new Error('La imagen ya contiene información GPS.');
      }
  
      // Función para convertir coordenadas decimales a formato EXIF DMS
      function toDMS(coordinate: number) {
        const absCoordinate = Math.abs(coordinate);
        const degrees = Math.floor(absCoordinate);
        const minutes = Math.floor((absCoordinate - degrees) * 60);
        const seconds = (absCoordinate - degrees - (minutes / 60)) * 3600;
        return [
          [degrees, 1],
          [minutes, 1],
          [Math.round(seconds * 100), 100]
        ];
      }
  
      // Configurar los datos GPS
      exifObj["GPS"][piexif.GPSIFD.GPSVersionID] = [2, 3, 0, 0];
      exifObj["GPS"][piexif.GPSIFD.GPSLatitudeRef] = coordenadasGPS.coords.latitude >= 0 ? 'N' : 'S';
      exifObj["GPS"][piexif.GPSIFD.GPSLatitude] = toDMS(coordenadasGPS.coords.latitude);
      exifObj["GPS"][piexif.GPSIFD.GPSLongitudeRef] = coordenadasGPS.coords.longitude >= 0 ? 'E' : 'W';
      exifObj["GPS"][piexif.GPSIFD.GPSLongitude] = toDMS(coordenadasGPS.coords.longitude);
      exifObj["GPS"][piexif.GPSIFD.GPSAltitudeRef] = coordenadasGPS.coords.altitude >= 0 ? 0 : 1; // 0 = Above Sea Level, 1 = Below Sea Level
      exifObj["GPS"][piexif.GPSIFD.GPSAltitude] = [Math.round(coordenadasGPS.coords.altitude), 1]; // Altitude in meters
  
      // Generar los nuevos bytes EXIF
      const exifBytes = piexif.dump(exifObj);
      const newDataURL = piexif.insert(exifBytes, imageData);
  
      return newDataURL;
  
    } catch (ex) {
      console.warn(`Error al escribir información EXIF al archivo`, ex);
      throw ex;
    }
  }

}
